const STEPS_INJECTION_KEY = "ElSteps";

export { STEPS_INJECTION_KEY };
//# sourceMappingURL=tokens.mjs.map
